export default "__VITE_ASSET__IriwYNm3__"